import React, { useEffect, useState } from 'react';
import { IconLockExtraLarge, IconTouchXL, IconUpdateL } from '../../../../icons';
import { IconSpinner } from '../../../../components';
import { cardAlreadyFlipped, cardWin } from './helpers';
import css from './FlipAndWinCards.css';
import classNames from 'classnames';
import { useConfetti } from '../../../../hooks/useConfetti';

export default ({ loading, currentUser, card, handleCardFlip = () => null }) => {
    const [flipped, setFlipped] = useState(false);
    const [confettiAllowed, setConfettiAllowed] = useState(false);

    const { flipAndWinData } = currentUser?.attributes?.profile?.privateData || {};
    const { newFlipAllowedAt, cardsFlipped } = flipAndWinData || { cardsFlipped: {} };

    const isWinCard = cardWin(card, cardsFlipped);
    const currentUserDefined = Boolean(currentUser?.id?.uuid);

    useConfetti({ isAllowed: confettiAllowed });

    const flipCard = card => {
        if (!card?.id) return;
        if (loading) return;
        if (cardAlreadyFlipped(card, cardsFlipped)) return;
        if (!currentUserDefined) return;
        if (newFlipAllowedAt) return;

        handleCardFlip(card);
        setFlipped(true);
    };

    useEffect(() => {
        /** show confetti is a user wins */
        if (flipped && isWinCard) {
            setConfettiAllowed(true);
        }
    }, [flipped, isWinCard]);

    const showNonAuthedContent = !loading && !currentUserDefined;
    const showAuthedContent = !loading && currentUserDefined;

    return (
        <div
            onClick={() => flipCard(card)}
            className={classNames(css.flipAndWinFrontSide, {
                [css.notAuthed]: !currentUserDefined,
                [css.notAllowedYet]: !!newFlipAllowedAt,
            })}
        >
            {/** Non flipped card content */}
            {showNonAuthedContent && <IconLockExtraLarge />}
            {showAuthedContent && (
                <>
                    <span className={css.quizzSymb}>?</span>
                    {!newFlipAllowedAt && <IconUpdateL />}
                    {!newFlipAllowedAt && <IconTouchXL />}
                </>
            )}
            {loading && <IconSpinner className={css.iconSpinner} />}
        </div>
    );
};
